module.exports = __webpack_public_path__ + "static/logos/mountain-forecast__icon-0c34b6d4fbb590eea7ee37eaf68f5203.svg";